import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {EMPTY, switchMap} from 'rxjs';
import {filter, map, take, withLatestFrom} from 'rxjs/operators';
import {AppState} from '../states/app.state';
import {DubletteNoticeDialogActions} from '../actions/dublette-notice-dialog.actions';
import {DubletteNoticeDialogSelectors} from '../selectors/dublette-notice-dialog.selectors';
import {EditSelectors} from '../selectors/edit.selectors';
import {BelegEntitiesSelectors} from '../selectors/beleg-entities.selectors';
import {BelegEntitiesActions} from '../actions/beleg-entities.actions';
import {NavigationService} from '@adnova/jf-ng-components';
import {BelegDTO} from '../../openapi/beleg-openapi';

@Injectable()
export class DubletteNoticeDialogEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private navigationService: NavigationService,
  ) {}

  readonly continueWithDublette$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DubletteNoticeDialogActions.continueWithDublette),
      withLatestFrom(
        this.store.select(DubletteNoticeDialogSelectors.intent),
        this.store.select(EditSelectors.belegId),
        this.navigationService.currentInhaber$,
        this.store.select(EditSelectors.updateBelegRequestDto),
      ),
      switchMap(([, intent, belegId, inhaber, updateBelegRequestDto]) => {
        if (!belegId || !inhaber) return EMPTY;

        return this.store.select(BelegEntitiesSelectors.belegById(inhaber.id, belegId)).pipe(
          take(1),
          filter((beleg): beleg is BelegDTO => !!beleg),
          map(belegDto => {
            if (intent === 'update') {
              return BelegEntitiesActions.updateBeleg({
                belegDto,
                updateBelegRequestDto,
                editNextBeleg: true,
              });
            } else if (intent === 'prepareZahlung') {
              return BelegEntitiesActions.updateBeleg({
                belegDto,
                updateBelegRequestDto,
                prepareZahlung: true,
              });
            } else if (belegDto.offen) {
              return BelegEntitiesActions.updateBeleg({
                belegDto,
                updateBelegRequestDto,
                stipulateBeleg: true,
                editNextBeleg: true,
              });
            } else {
              return BelegEntitiesActions.stipulateBeleg({
                inhaberId: belegDto.inhaberId,
                belegId: belegDto.id,
                editNextBeleg: true,
              });
            }
          }),
        );
      }),
    ),
  );
}
